import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Collapse,
  DialogTitle,
} from '@material-ui/core';
// import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import CreateIcon from '@material-ui/icons/Create';
import axios from 'axios';
import { appUrl } from '../../../../../utils/config';
import OtherInfo from '../supplierPoAdd/OtherInfo';
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from '../../../containers/actions/types';
import { useDispatch } from 'react-redux';
import { presentFormatedData } from '../functionalComponents/dataFormatFunctions';
import CustomDatePickerMui from '../models/inputs/DateInput';
import FileViewer from '../supplierPOCoAFileViewer/FileViewer';
import BackDropLoading from '../models/BackDrop';
import { SupplierPOContext } from '../grnReceipts/context';
import StyledDialog from '../../../../common/models/Dialog';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  inline: {
    fontSize: '1.35rem',
    display: 'inline',
    fontWeight: 550,
    marginBottom: '0.5rem',
  },
  hrLine: {
    backgroundColor: 'grey',
    width: '2.5rem',
    height: '3px',
    margin: 'inherit',
    marginBottom: '1rem',
    marginTop: '0.25rem',
  },
  hrdis: {
    backgroundColor: 'grey',
    // width: '2.5rem',
    height: '3px',
    margin: 'inherit',
    marginBottom: '1rem',
    marginTop: '0.25rem',
  },
  orangeButton: {
    backgroundColor: '#F26B38',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 25,
    padding: '8px 20px',
    '&:hover': {
      backgroundColor: '#d55b2e',
    },
  },
  whiteButton: {
    backgroundColor: '#fff',
    color: '#000',
    border: '1px solid #999',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 25,
    padding: '8px 20px',
    '&:hover': {
      backgroundColor: '#000',
      color: '#fff',
    },
  },
  dialogContent: {
    textAlign: 'center',
    padding: '80px 100px',
    // padding: '5rem',
  },
  checkIcon: {
    // color: 'green',
    fontSize: 60,
    marginBottom: 40,
  },
  okButton: {
    backgroundColor: '#F26B38',
    color: '#fff',
    textTransform: 'none',
    borderRadius: 25,
    padding: '6px 25px',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#d55b2e',
    },
  },
  closeText: {
    color: 'blue',
    textDecoration: 'underline',
  },
  sectionTitle: {
    fontWeight: 500,
  },
  staticValue: {
    fontWeight: 400,
  },
}));

const ResolveReviewFile = (props) => {
  const classes = useStyles();
  const errorRef = useRef();
  const dispatch = useDispatch();
  const [openFileView, setOpenFileView] = useState(false);
  const [coaId, setCoAId] = useState(null);
  const {
    GRData,
    POLineRecordDetails,
    onClose,
    asnData,
    setAsnData,
    batchData,
    setBatchData,
    poDetails,
    otherFiles,
    setOtherFiles,
    POBatchRecordDetails,
    // setPOBatchRecordDetails,
    handleChange,
    handlingFiles,
    parentHandlingDeleteFile,
    OtherInfoTempNumber,
    handleTempNumber,
    otherInformationRemarks,
    setOtherInformation,
    // coaName,
  } = props;
  const { fetchGRLineItems } = useContext(SupplierPOContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [submitDialog, setSubmitDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingBatch, setIsEditingBatch] = useState(false);
  const [isEditingFiles, setIsEditingFiles] = useState(false);
  const [tempData, setTempData] = useState(asnData);
  // const [open, setOpen] = useState(true);
  const [openPO, setOpenPO] = useState(true);
  const [openASN, setOpenASN] = useState(true);
  const [openBatch, setOpenBatch] = useState(true);
  const [tempBatchData, setTempBatchData] = useState(batchData);
  const [updateGRNData, setUpdateGRNData] = useState(null);
  const [callUpdateGRN, setCallUpdateGRN] = useState(false);
  const [discrepancyDialog, setDiscrepancyDialog] = useState(false);
  const [otherInformationEdit, setOtherInformationEdit] = useState(
    otherInformationRemarks
  );
  const [errors, setErrors] = useState({ errorFields: [], errorTitle: '' });

  // console.log('updateGRNData', updateGRNData);

  const togglePO = () => setOpenPO(!openPO);
  const toggleASN = () => setOpenASN(!openASN);
  const toggleBatch = () => setOpenBatch(!openBatch);

  // console.log('GRData', GRData);
  // console.log('POLineRecordDetails', POLineRecordDetails);
  // console.log('asnData', asnData);
  // console.log('tempBatchData', tempBatchData);
  // console.log('tempData', tempData);
  // console.log('batchData', batchData);
  // console.log('poDetails', poDetails);

  // Early return if critical data is missing
  if (!POLineRecordDetails || !GRData) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <Typography>No record data available</Typography>
      </div>
    );
  }

  const handleSaveRecord = () => {
    setOpenDialog(true);
  };

  const handleSubmitRecord = () => {
    // setCallUpdateGRN(true);
    if (
      Number(batchData?.asnBatchQuantity) ===
        Number(batchData?.actualQuantityReceived) &&
      asnData?.vehicleNumberSupplier === asnData?.vehicleNumberCMO
    ) {
      // No discrepancy → directly call API
      setCallUpdateGRN(true);
    } else {
      // Show discrepancy dialog first
      setDiscrepancyDialog(true);
    }
  };

  const scrollToTop = () => {
    setTimeout(
      () =>
        errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' }),
      100
    );
  };

  const handleDiscrepancyConfirm = () => {
    setDiscrepancyDialog(false);
    setCallUpdateGRN(true);
  };

  const handleClose = () => {
    // setOpen(false);
    if (updateGRNData?.status === true) {
      fetchGRLineItems();
      onClose();
    } else {
      setSubmitDialog(false);
      setDiscrepancyDialog(false);
      scrollToTop();
    }
  };

  useEffect(() => {
    if (updateGRNData?.status === false) {
      scrollToTop();
    }
  }, [updateGRNData]);

  useEffect(() => {
    // console.log('call', callUpdateGRN);
    if (callUpdateGRN === true) {
      // setSubmitDialog(true);
      const updateGRN = async () => {
        // setLoading(true);

        const requestData = {
          PODetails: {
            ...poDetails,
            POLineRecordDetails: {
              ...poDetails?.POLineRecordDetails,
              schrockenSupplierPOLineID:
                poDetails?.POLineRecordDetails?.schrockenSupplierPOLineID || '',
              supplierPurchaseOrderNumber:
                poDetails?.POLineRecordDetails?.supplierPurchaseOrderNumber,
              materialCode: poDetails?.POLineRecordDetails?.materialCode,
              supplierPODate: poDetails?.POLineRecordDetails?.supplierPODate,
              materialType: poDetails?.POLineRecordDetails?.materialType,
              materialName: poDetails?.POLineRecordDetails?.materialName,
              unitOfMeasurementOrdered:
                poDetails?.POLineRecordDetails?.unitOfMeasurementOrdered,
              // quantityOrdered: batchData?.asnBatchQuantity,
              quantityOrdered: poDetails?.POLineRecordDetails?.quantityOrdered,
              totalQuantityReceived:
                poDetails?.POLineRecordDetails?.totalQuantityReceived,
              supplierName: poDetails?.POLineRecordDetails?.supplierName,
              supplierAddress: poDetails?.POLineRecordDetails?.supplierAddress,
              vendorAddress: poDetails?.POLineRecordDetails?.vendorAddress,
              statusID: poDetails?.POLineRecordDetails?.statusID,
              statusText: poDetails?.POLineRecordDetails?.statusText,
              unitOfMeasureSKU:
                poDetails?.POLineRecordDetails?.unitOfMeasureSKU,
              overDeliveryTolerance:
                poDetails?.POLineRecordDetails?.overDeliveryTolerance,
              minShelfLife: poDetails?.POLineRecordDetails?.minShelfLife,
              totalShelfLife: poDetails?.POLineRecordDetails?.totalShelfLife,
              shelfLifeUnitIndicator:
                poDetails?.POLineRecordDetails?.shelfLifeUnitIndicator,
              // lastUpdatedDate: poDetails?.POLineRecordDetails?.,
              quantityYetToReceive:
                poDetails?.POLineRecordDetails?.quantityYetToReceive,
              scheduledDeliveryDate:
                poDetails?.POLineRecordDetails?.scheduledDeliveryDate,
            },
            GRDetails: {
              ...poDetails?.GRDetails,
              POBatchRecordDetails: {
                ...poDetails?.GRDetails?.POBatchRecordDetails,
                schrockenSupplierPOBatchID:
                  poDetails?.GRDetails?.POBatchRecordDetails
                    ?.schrockenSupplierPOBatchID,
                numberGRN:
                  poDetails?.GRDetails?.POBatchRecordDetails?.numberGRN,
                numberQC: poDetails?.GRDetails?.POBatchRecordDetails?.numberQC,
                costCenterNumber:
                  poDetails?.GRDetails?.POBatchRecordDetails?.costCenterNumber,
                numberMRN: batchData?.numberMRN,
                transporterName: asnData?.transporterName,
                lorryReceiptNumber: asnData?.lorryReceiptNumber,
                lorryReceiptDate:
                  poDetails?.GRDetails?.POBatchRecordDetails?.lorryReceiptDate,
                approvedBy:
                  poDetails?.GRDetails?.POBatchRecordDetails?.approvedBy,
                batchStatusID:
                  poDetails?.GRDetails?.POBatchRecordDetails?.batchStatusID,
                batchStatusText:
                  poDetails?.GRDetails?.POBatchRecordDetails?.batchStatusText,
                materialReceivedDate: batchData?.materialReceivedDate
                  ? new Date(batchData?.materialReceivedDate).toISOString()
                  : '',
                otherInformationRemarks: otherInformationRemarks,
                otherFiles: otherFiles,
                isSubmitForApproval: true,
                isExceedQuantityAllowed: false,
              },
              receivedQuantityInfo: {
                ...poDetails?.GRDetails?.receivedQuantityInfo,
                actualQuantityReceived:
                  Number(batchData?.actualQuantityReceived) || 0,
                unitOfMeasurementReceived:
                  poDetails?.POLineRecordDetails?.unitOfMeasurementOrdered,
                quantityYetToReceive:
                  poDetails?.GRDetails?.receivedQuantityInfo
                    ?.quantityYetToReceive,
              },
              qualityAssuranceInfo: {
                ...poDetails?.GRDetails?.qualityAssuranceInfo,
                unitOfMeasurementQA:
                  poDetails?.GRDetails?.qualityAssuranceInfo
                    ?.unitOfMeasurementQA,
                samplingQuantityQA:
                  poDetails?.GRDetails?.qualityAssuranceInfo
                    ?.samplingQuantityQA,
                isQACompleted:
                  poDetails?.GRDetails?.qualityAssuranceInfo?.isQACompleted,
                // analyticalReportNumber: batchData?.analyticalReportNumber,
                batchNumberQA: batchData?.batchNumberQA,
                analyticalReportDate:
                  poDetails?.GRDetails?.qualityAssuranceInfo
                    ?.analyticalReportDate,
                materialManufactureDate: batchData?.materialManufactureDate
                  ? new Date(batchData?.materialManufactureDate).toISOString()
                  : '',
                expirationDate: batchData?.expirationDate
                  ? new Date(batchData?.expirationDate).toISOString()
                  : '',
                samplingMaterialNumberQA:
                  poDetails?.GRDetails?.qualityAssuranceInfo
                    ?.samplingMaterialNumberQA,
                COAFiles: poDetails?.GRDetails?.qualityAssuranceInfo?.COAFiles,
                // (doubt)
              },
              challanInformation: {
                ...poDetails?.GRDetails?.challanInformation,
                challanNumber: asnData?.challanNumber,
                challanDate: asnData?.challanDate
                  ? new Date(asnData?.challanDate).toISOString()
                  : '',
                challanFiles:
                  poDetails?.GRDetails?.challanInformation?.challanFiles,
                // (doubt)
                ewayBillNumber:
                  poDetails?.GRDetails?.challanInformation?.ewayBillNumber,
                ewayBillDate:
                  poDetails?.GRDetails?.challanInformation?.ewayBillDate,
                vehicleNumberCMO: asnData?.vehicleNumberCMO,
                // vehicleNumberCMO: asnData?.vehicleNumberCMO,
              },
              invoiceInformation: {
                ...poDetails?.GRDetails?.invoiceInformation,
                invoiceNumber: asnData?.invoiceNumber,
                // invoiceDate: asnData?.invoiceDate,
                invoiceDate: asnData?.invoiceDate
                  ? new Date(asnData.invoiceDate).toISOString()
                  : '',
                invoiceFiles:
                  poDetails?.GRDetails?.invoiceInformation?.invoiceFiles,
              },
            },
          },
        };

        let backdropText = 'Please Wait. Sending for approval ....';

        dispatch({
          type: OPEN_BACKDROP,
          backdropText,
        });

        axios
          .post(
            `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateGRN`,
            requestData
          )
          .then((res) => {
            // console.log('Full response:', res); // To see the entire structure
            // console.log('Status:', res.data.status); // ✅ Prints true/false
            // console.log('Error Message:', res.data.errorMessage); // ✅ Prints error message if any

            setUpdateGRNData(res.data);

            if (res.data.status) {
              setSubmitDialog(true);
            }
          })
          .catch((err) => {
            console.error('API Error:', err.response.data);
            if (err.response?.data) {
              setUpdateGRNData(err.response.data);
            } else {
              setUpdateGRNData({
                status: false,
                errorMessage: 'Network error. Please try again.',
              });
            }
          })
          .finally(() => {
            setCallUpdateGRN(false);
            dispatch({
              type: DESTROY_BACKDROP,
            });
          });
      };
      updateGRN();
    }
  }, [callUpdateGRN]);

  // const handleAsnDataChange = (e) => {
  //   const { name, value } = e.target;
  //   setEditedData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  useEffect(() => {
    setTempData(asnData);
  }, [asnData]);

  useEffect(() => {
    setTempBatchData(batchData);
  }, [batchData]);

  // useEffect(() => {
  //   setTempData(otherInformationRemarks);
  // }, [otherInformationRemarks]);

  const handleBatchChange = (e) => {
    // const { name, value } = e.target;
    // setTempBatchData((prev) => ({
    //   ...prev,
    //   [name]: value,
    // }));
    setTempBatchData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleEdit = () => {
    setIsEditing(true);
  };
  const handleEditbatch = () => {
    setIsEditingBatch(true);
  };
  const handleEditFiles = () => {
    setIsEditingFiles(true);
  };

  const handleAsnDataChange = (e) => {
    setTempData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSave = () => {
    if (handleValidation(tempData, tempBatchData)) {
      setAsnData(tempData);
      setIsEditing(false);
    }
  };

  const handleSaveBatch = () => {
    if (handleValidation(tempData, tempBatchData)) {
      setBatchData(tempBatchData); // revert batch edits
      setIsEditingBatch(false);
    }
  };

  const handleSaveOtherInfo = () => {
    setOtherInformation(otherInformationEdit);
    setIsEditingFiles(false);
  };

  const handleCancel = () => {
    setTempData(asnData);
    setTempBatchData(batchData);
    setIsEditing(false);
    setIsEditingBatch(false);
    setIsEditingFiles(false);
  };

  const handleDownload = (Id) => {
    if (Id) {
      let backdropText = 'Downloading, Please Wait...';
      dispatch({
        type: OPEN_BACKDROP,
        backdropText,
      });
      // axios
      //   .get(
      //     `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/getCOADetails/download/${Id}`
      //   )
      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadGRFiles`,
          { schrockenGRFileId: Id }
        )
        .then((res) => {
          if (res.data.status) {
            let fileDataArray = res.data.fileData.data;
            var byteArray = new Uint8Array(fileDataArray);

            var a = window.document.createElement('a');

            a.href = window.URL.createObjectURL(
              new Blob([byteArray], { type: 'application/octet-stream' })
            );
            a.download = res.data.fileName;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
          dispatch({
            type: DESTROY_BACKDROP,
          });
        })
        .catch((err) => {
          console.log(err);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        });
    }
  };

  const handleValidation = (ansObj, batchObj) => {
    let valid = true;
    let errorFields = [];
    let errorText = '';
    if (!ansObj?.lorryReceiptNumber) {
      valid = false;
      errorFields.push('lorryReceiptNumber');
      errorText = 'Enter Lorry Receipt (LR) Number';
    }
    if (!ansObj?.transporterName) {
      valid = false;
      errorFields.push('transporterName');
      errorText = 'Enter Transporter Name.';
    }
    if (!ansObj?.invoiceNumber) {
      valid = false;
      errorFields.push('invoiceNumber');
      errorText = 'Enter invoice number.';
    }
    if (!ansObj?.invoiceDate) {
      valid = false;
      errorFields.push('invoiceDate');
      errorText = 'Enter invoice date.';
    }
    // if (!batchObj?.analyticalReportNumber) {
    //   valid = false;
    //   errorFields.push('analyticalReportNumber');
    //   errorText = 'Enter analytical report number.';
    // }
    if (!batchObj?.batchNumberQA) {
      valid = false;
      errorFields.push('batchNumberQA');
      errorText = 'Enter Supplier Batch Number.';
    }
    if (!batchObj?.numberMRN) {
      valid = false;
      errorFields.push('numberMRN');
      errorText = 'Enter MRN number.';
    }
    if (!parseFloat(batchObj?.actualQuantityReceived)) {
      valid = false;
      errorFields.push('actualQuantityReceived');
      errorText = 'Enter actual quantity received.';
    }
    if (!batchObj?.materialReceivedDate) {
      valid = false;
      errorFields.push('materialReceivedDate');
      errorText = 'Enter material received date.';
    }
    if (!batchObj?.expirationDate) {
      valid = false;
      errorFields.push('expirationDate');
      errorText = 'Enter expiration date.';
    }
    if (!batchObj?.materialManufactureDate) {
      valid = false;
      errorFields.push('materialManufactureDate');
      errorText = 'Enter manufacture date.';
    }

    if (batchObj?.materialManufactureDate && batchObj?.expirationDate) {
      const date1 = new Date(batchObj?.materialManufactureDate);
      const date2 = new Date(batchObj?.expirationDate);

      if (date1 > date2) {
        valid = false;
        errorFields.push('expirationDate');
        errorText = 'Please enter valid expiration Date.';
      }
    }

    if (errorFields.length > 1) {
      errorText = 'Some required fields are missing.';
    }

    setErrors({
      errorFields: errorFields,
      errorTitle: errorText,
    });
    return valid;
  };

  useEffect(() => {
    setErrors({
      errorFields: [],
      errorTitle: '',
    });
  }, [tempData, tempBatchData]);

  return (
    <>
      <BackDropLoading />
      <div
        //  style={{ marginLeft: '2rem' }}
        style={{
          width: '60vw',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          marginLeft: '22vw',
          marginRight: '22vw',
        }}
      >
        {(updateGRNData?.status === false ||
          (errors.errorFields.length > 0 && errors.errorTitle !== '')) && (
          <Grid
            container
            ref={(el) => {
              errorRef.current = el;
            }}
            justifyContent='center'
            style={{
              padding: '1rem 0',
            }}
          >
            <Grid item xs={10}>
              <Typography
                variant='h6'
                style={{
                  border: '1px solid #FF0000',
                  backgroundColor: '#FFF0F0',
                  opacity: '1',
                  padding: '1rem',
                  fontSize: '0.875rem',
                  textAlign: 'center',
                }}
              >
                {errors.errorFields.length > 0 && errors.errorTitle !== ''
                  ? errors.errorTitle
                  : 'Something went Wrong. Please contact Schrocken support.'}
              </Typography>
            </Grid>
          </Grid>
        )}
        {/* Header with arrow */}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            cursor: 'pointer',
          }}
          onClick={togglePO}
        >
          <IconButton size='small'>
            {openPO ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
          <div>
            <Typography
              variant='body1'
              style={{ fontWeight: 600, fontSize: '1.5rem' }}
            >
              PO Details
            </Typography>
            <hr className={classes.hrLine} />
          </div>
        </div>

        <Collapse in={openPO} timeout='200'>
          <Grid container spacing={3}>
            {/* Row 1 */}
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                PO / STO Number
              </Typography>
              <Typography>
                {POLineRecordDetails?.supplierPurchaseOrderNumber || '-NA-'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                PO Date
              </Typography>
              <Typography>
                {POLineRecordDetails?.supplierPODate
                  ? presentFormatedData(
                      new Date(
                        POLineRecordDetails?.supplierPODate.split('T')[0]
                      )
                        .toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/ /g, '-'),
                      'NA'
                    )
                  : 'NA'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Sch Delivery Date
              </Typography>
              <Typography>
                {POLineRecordDetails?.scheduledDeliveryDate
                  ? presentFormatedData(
                      new Date(
                        POLineRecordDetails?.scheduledDeliveryDate.split('T')[0]
                      )
                        .toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/ /g, '-'),
                      'NA'
                    )
                  : 'NA'}
              </Typography>
            </Grid>

            {/* Row 2 */}
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Material Type
              </Typography>
              <Typography>{POLineRecordDetails?.materialType}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Material Name / Description
              </Typography>
              <Typography>{POLineRecordDetails?.materialName}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Code
              </Typography>
              <Typography>{POLineRecordDetails?.materialCode}</Typography>
            </Grid>

            {/* Row 3 */}
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                UOM
              </Typography>
              <Typography>
                {POLineRecordDetails?.unitOfMeasurementOrdered}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Quantity
              </Typography>
              <Typography>{POLineRecordDetails?.quantityOrdered}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Delivery Tolerance
              </Typography>
              <Typography>
                {POLineRecordDetails?.overDeliveryTolerance}
              </Typography>
            </Grid>

            {/* Row 4 */}
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Shelf Life
              </Typography>
              <Typography>
                {POLineRecordDetails?.minShelfLife}{' '}
                {POLineRecordDetails?.shelfLifeUnitIndicator}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Supplier Name
              </Typography>
              <Typography>{POLineRecordDetails?.supplierName}</Typography>
            </Grid>
            {/* <Grid item xs={12} sm={4}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                Batch Status
              </Typography>
              <Typography>{GRData?.batchStatusText}</Typography>
            </Grid> */}
            {/* Empty column to maintain alignment under 3-column grid */}
            <Grid item xs={12} sm={4}></Grid>
          </Grid>
        </Collapse>

        <Grid
          container
          style={{
            marginTop: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          spacing={2}
        >
          <Grid
            item
            xs={12}
            sm={6}
            style={{
              marginTop: '0.5rem',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
            }}
          >
            <Grid>
              <IconButton onClick={toggleASN} size='small'>
                {openASN ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowRightIcon />
                )}
              </IconButton>
            </Grid>
            <Grid>
              <Typography
                // className={classes.inline}
                variant='body1'
                style={{ fontWeight: 600, fontSize: '1.5rem' }}
                // variant='body2'
                // style={{ fontWeight: 500 }}
              >
                ASN / GRN Input Details
              </Typography>
              <hr className={classes?.hrLine} />
            </Grid>
          </Grid>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            item
            xs={12}
            sm={6}
          >
            {isEditing ? (
              <>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleSave}
                  style={{ marginRight: 8 }}
                >
                  Save
                </Button>
                <Button variant='outlined' onClick={handleCancel}>
                  Cancel
                </Button>
              </>
            ) : (
              // <Button
              //   variant='contained'
              //   color='default'
              //   onClick={() => setIsEditing(true)}
              // >
              //   Edit
              // </Button>
              <Button
                variant='contained'
                startIcon={<CreateIcon fontSize='small' />}
                style={{
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  border: '1px solid #000000de',
                }}
                size='small'
                // onClick={() => setIsEditing(true)}
                onClick={handleEdit}
              >
                Edit
              </Button>
            )}
          </Grid>
        </Grid>
        <Collapse in={openASN} timeout='200'>
          <Grid container spacing={3}>
            {/* Row 1 — 3 columns */}
            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                ASN Number
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData?.asnNumber || '-'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                ASN Document Date
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData?.asnDocumentDate
                  ? presentFormatedData(
                      new Date(asnData?.asnDocumentDate.split('T')[0])
                        .toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/ /g, '-'),
                      'NA'
                    )
                  : 'NA'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                ASN Schedule Delivery Date
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData?.asnScheduleDeliveryDate
                  ? presentFormatedData(
                      new Date(asnData?.asnScheduleDeliveryDate.split('T')[0])
                        .toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/ /g, '-'),
                      'NA'
                    )
                  : 'NA'}
              </Typography>
            </Grid>

            {/* Row 2 — 2 columns aligned under first two columns */}
            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                E-way Bill No.
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData?.ewayBillNumber || '-'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                E-way Bill Date
              </Typography>
              <Typography className={classes.staticValue}>
                {asnData?.ewayBillDate
                  ? presentFormatedData(
                      new Date(asnData?.ewayBillDate.split('T')[0])
                        .toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/ /g, '-'),
                      'NA'
                    )
                  : 'NA'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}></Grid>

            {/* Row 3 — 2 columns */}
            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>BoE No.</Typography>
              <Typography className={classes.staticValue}>
                {asnData?.boeNumber || '-'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>BoE Date</Typography>
              <Typography className={classes.staticValue}>
                {asnData?.boeDate
                  ? presentFormatedData(
                      new Date(asnData?.boeDate.split('T')[0])
                        .toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/ /g, '-'),
                      'NA'
                    )
                  : 'NA'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}></Grid>

            {/* Editable Fields (conditional) */}
            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Lorry Receipt (LR) Number{' '}
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditing ? (
                <TextField
                  size='small'
                  variant='outlined'
                  name='lorryReceiptNumber'
                  value={tempData.lorryReceiptNumber}
                  onChange={handleAsnDataChange}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('lorryReceiptNumber')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('lorryReceiptNumber')
                      ? 'Enter LR Number.'
                      : ''
                  }
                />
              ) : (
                <Typography className={classes.staticValue}>
                  {asnData.lorryReceiptNumber || '-'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Transporter Name <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditing ? (
                <TextField
                  size='small'
                  variant='outlined'
                  name='transporterName'
                  value={tempData.transporterName}
                  onChange={handleAsnDataChange}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('transporterName')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('transporterName')
                      ? 'Enter Transporter Name.'
                      : ''
                  }
                />
              ) : (
                <Typography className={classes.staticValue}>
                  {asnData.transporterName || '-'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}></Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Invoice Number <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditing ? (
                <TextField
                  size='small'
                  variant='outlined'
                  name='invoiceNumber'
                  value={tempData.invoiceNumber}
                  onChange={handleAsnDataChange}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('invoiceNumber')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('invoiceNumber')
                      ? 'Enter invoice number.'
                      : ''
                  }
                />
              ) : (
                <Typography className={classes.staticValue}>
                  {asnData.invoiceNumber || '-'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Invoice Date <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditing ? (
                <TextField
                  variant='outlined'
                  size='small'
                  type='date'
                  name='invoiceDate'
                  InputLabelProps={{ shrink: true }}
                  value={
                    tempData.invoiceDate
                      ? tempData.invoiceDate.split('T')[0]
                      : ''
                  }
                  onChange={handleAsnDataChange}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('invoiceDate')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('invoiceDate')
                      ? 'Enter invoice date.'
                      : ''
                  }
                />
              ) : (
                <Typography className={classes.staticValue}>
                  {asnData.invoiceDate
                    ? presentFormatedData(
                        new Date(asnData.invoiceDate.split('T')[0])
                          .toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })
                          .replace(/ /g, '-'),
                        'NA'
                      )
                    : 'NA'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}></Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Challan Number
              </Typography>
              {isEditing ? (
                <TextField
                  size='small'
                  variant='outlined'
                  name='challanNumber'
                  value={tempData.challanNumber}
                  onChange={handleAsnDataChange}
                />
              ) : (
                <Typography className={classes.staticValue}>
                  {asnData.challanNumber || '-'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Challan Date
              </Typography>
              {isEditing ? (
                <TextField
                  variant='outlined'
                  type='date'
                  size='small'
                  name='challanDate'
                  InputLabelProps={{ shrink: true }}
                  value={
                    tempData.challanDate
                      ? tempData.challanDate.split('T')[0]
                      : ''
                  }
                  onChange={handleAsnDataChange}
                />
              ) : (
                <Typography className={classes.staticValue}>
                  {asnData.challanDate
                    ? presentFormatedData(
                        new Date(asnData.challanDate.split('T')[0])
                          .toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })
                          .replace(/ /g, '-'),
                        'NA'
                      )
                    : 'NA'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}></Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Vehicle Number (Supplier)
              </Typography>
              {isEditing ? (
                <TextField
                  size='small'
                  variant='outlined'
                  name='vehicleNumberSupplier'
                  value={tempData.vehicleNumberSupplier}
                  onChange={handleAsnDataChange}
                  disabled
                />
              ) : (
                <Typography className={classes.staticValue}>
                  {asnData.vehicleNumberSupplier || '-'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography className={classes.sectionTitle}>
                Vehicle Number (CMO)
              </Typography>
              {isEditing ? (
                <TextField
                  size='small'
                  variant='outlined'
                  name='vehicleNumberCMO'
                  value={tempData.vehicleNumberCMO}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only alphanumeric, dash, and space, and max 15 chars
                    const regex = /^[A-Za-z0-9\- ]{0,15}$/;

                    if (regex.test(value)) {
                      handleAsnDataChange(e);
                    }
                  }}
                  inputProps={{
                    maxLength: 15, // extra safeguard for input length
                  }}
                  // onChange={handleAsnDataChange}
                />
              ) : (
                <Typography className={classes.staticValue}>
                  {asnData?.vehicleNumberCMO || '-'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}></Grid>

            <Grid item xs={12}>
              <Typography className={classes.sectionTitle}>CoA</Typography>
              {/* {asnData?.coaDocumentID ? (
                <Typography
                  style={{
                    color: 'blue',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  variant='body2'
                  className={classes.fontPadding}
                  // onClick={() => handleDownload(asnData?.coaDocumentID)}
                  onClick={() => setOpenFileView(true)}
                >
                  {coaName}
                </Typography>
              ) : (
                <Typography variant='body2' className={classes.fontPadding}>
                  NA
                </Typography>
              )} */}
              {Array.isArray(asnData.COAFiles) &&
              asnData.COAFiles.length > 0 ? (
                asnData.COAFiles.map((val) => {
                  return (
                    <Typography
                      style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                      variant='body2'
                      className={classes.fontPadding}
                      // onClick={() => handleDownload(asnData?.coaDocumentID)}
                      onClick={() => {
                        setCoAId(val.schrockenGRFileId);
                        setOpenFileView(true);
                      }}
                    >
                      {val.grFileName}
                    </Typography>
                  );
                })
              ) : (
                <Typography variant='body2' className={classes.fontPadding}>
                  NA
                </Typography>
              )}
            </Grid>
            <FileViewer
              fileId={coaId}
              openFileView={openFileView}
              handleFileViewClose={() => setOpenFileView(false)}
              downloadFile={handleDownload}
            />
          </Grid>
        </Collapse>

        <Grid
          container
          style={{
            marginTop: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          spacing={2}
        >
          <Grid
            item
            xs={12}
            sm={6}
            style={{
              marginTop: '0.5rem',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
            }}
          >
            <Grid>
              <IconButton onClick={toggleBatch} size='small'>
                {openBatch ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowRightIcon />
                )}
              </IconButton>
            </Grid>
            <Grid>
              <Typography
                // className={classes.inline}
                variant='body1'
                style={{ fontWeight: 600, fontSize: '1.5rem' }}
                // variant='body2'
                // style={{ fontWeight: 500 }}
              >
                Batch Details
              </Typography>
              <hr className={classes?.hrLine} />
            </Grid>
          </Grid>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            item
            xs={12}
            sm={6}
          >
            {isEditingBatch ? (
              <>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleSaveBatch}
                  style={{ marginRight: 8 }}
                >
                  Save
                </Button>
                <Button variant='outlined' onClick={handleCancel}>
                  Cancel
                </Button>
              </>
            ) : (
              // <Button
              //   variant='contained'
              //   color='default'
              //   onClick={() => setIsEditing(true)}
              // >
              //   Edit
              // </Button>
              <Button
                variant='contained'
                startIcon={<CreateIcon fontSize='small' />}
                style={{
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  border: '1px solid #000000de',
                }}
                size='small'
                // onClick={() => setIsEditing(true)}
                onClick={handleEditbatch}
              >
                Edit
              </Button>
            )}
          </Grid>
        </Grid>

        <Collapse in={openBatch} timeout='200'>
          <Grid container spacing={3}>
            {/* Row 1 */}
            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                {/* Analytical Report (AR) Number */}
                Supplier Batch Number <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditingBatch ? (
                <TextField
                  size='small'
                  variant='outlined'
                  placeholder='Enter Supplier Batch Number...'
                  name='batchNumberQA'
                  disabled={asnData.asnNumber ? true : false}
                  value={tempBatchData.batchNumberQA || ''}
                  onChange={handleBatchChange}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('batchNumberQA')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('batchNumberQA')
                      ? 'Enter Supplier Batch no.'
                      : ''
                  }
                />
              ) : (
                // <TextField
                //   size='small'
                //   variant='outlined'
                //   placeholder='Enter Supplier Batch Number...'
                //   name='analyticalReportNumber'
                //   disabled={asnData.asnNumber ? true : false}
                //   value={tempBatchData.analyticalReportNumber || ''}
                //   onChange={handleBatchChange}
                //   error={
                //     Array.isArray(errors.errorFields) &&
                //     errors.errorFields.includes('analyticalReportNumber')
                //   }
                //   helperText={
                //     Array.isArray(errors.errorFields) &&
                //     errors.errorFields.includes('analyticalReportNumber')
                //       ? 'Enter Supplier Batch no.'
                //       : ''
                //   }
                // />
                <Typography>
                  {/* {batchData.analyticalReportNumber || '-'} */}
                  {batchData.batchNumberQA || '-'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Enter MRN Number <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditingBatch ? (
                <TextField
                  size='small'
                  variant='outlined'
                  placeholder='Enter MRN Number...'
                  name='numberMRN'
                  value={tempBatchData.numberMRN || ''}
                  onChange={handleBatchChange}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('numberMRN')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('numberMRN')
                      ? 'Enter MRN no.'
                      : ''
                  }
                />
              ) : (
                <Typography>{batchData.numberMRN || '-'}</Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}></Grid>

            {/* Row 2 */}
            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                ASN Batch Quantity
              </Typography>
              {isEditingBatch ? (
                <TextField
                  size='small'
                  variant='outlined'
                  name='asnBatchQuantity'
                  value={tempBatchData.asnBatchQuantity || ''}
                  onChange={handleBatchChange}
                  disabled
                />
              ) : (
                <Typography>{batchData.asnBatchQuantity || '-'}</Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Enter Actual Quantity Received{' '}
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditingBatch ? (
                <TextField
                  size='small'
                  variant='outlined'
                  placeholder='Enter Actual Quantity...'
                  name='actualQuantityReceived'
                  value={tempBatchData.actualQuantityReceived || ''}
                  onChange={handleBatchChange}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                  }}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('actualQuantityReceived')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('actualQuantityReceived')
                      ? 'Enter Actual Quantity Received.'
                      : ''
                  }
                />
              ) : (
                <Typography>
                  {batchData.actualQuantityReceived || '-'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>UOM</Typography>
              {isEditingBatch ? (
                <TextField
                  size='small'
                  variant='outlined'
                  placeholder='UOM...'
                  name='uom'
                  value={tempBatchData?.asnUOM || ''}
                  onChange={handleBatchChange}
                  disabled
                />
              ) : (
                <Typography>{batchData?.asnUOM || 'NA'}</Typography>
              )}
            </Grid>

            {/* Row 3 */}
            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Enter Quantity Received Date{' '}
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditingBatch ? (
                <TextField
                  size='small'
                  variant='outlined'
                  type='date'
                  name='materialReceivedDate'
                  InputLabelProps={{ shrink: true }}
                  value={
                    tempBatchData.materialReceivedDate
                      ? tempBatchData.materialReceivedDate.split('T')[0]
                      : ''
                  }
                  onChange={handleBatchChange}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('materialReceivedDate')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('materialReceivedDate')
                      ? 'Enter Quantity Received Date'
                      : ''
                  }
                />
              ) : (
                <Typography>
                  {batchData.materialReceivedDate
                    ? presentFormatedData(
                        new Date(batchData.materialReceivedDate.split('T')[0])
                          .toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })
                          .replace(/ /g, '-'),
                        'NA'
                      )
                    : 'NA'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Date of Expiration <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditingBatch ? (
                <TextField
                  size='small'
                  variant='outlined'
                  type='date'
                  name='expirationDate'
                  InputLabelProps={{ shrink: true }}
                  value={
                    tempBatchData.expirationDate
                      ? tempBatchData.expirationDate.split('T')[0]
                      : ''
                  }
                  onChange={handleBatchChange}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('expirationDate')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('expirationDate')
                      ? 'Enter Expiration Date'
                      : ''
                  }
                />
              ) : (
                <Typography>
                  {batchData.expirationDate
                    ? presentFormatedData(
                        new Date(batchData.expirationDate.split('T')[0])
                          .toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })
                          .replace(/ /g, '-'),
                        'NA'
                      )
                    : 'NA'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography style={{ fontWeight: 500 }}>
                Date of Manufacturing <span style={{ color: 'red' }}>*</span>
              </Typography>
              {isEditingBatch ? (
                <TextField
                  size='small'
                  variant='outlined'
                  type='date'
                  name='materialManufactureDate'
                  InputLabelProps={{ shrink: true }}
                  value={
                    tempBatchData.materialManufactureDate
                      ? tempBatchData.materialManufactureDate.split('T')[0]
                      : ''
                  }
                  onChange={handleBatchChange}
                  error={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('materialManufactureDate')
                  }
                  helperText={
                    Array.isArray(errors.errorFields) &&
                    errors.errorFields.includes('materialManufactureDate')
                      ? 'Enter Manufacture Date'
                      : ''
                  }
                />
              ) : (
                <Typography>
                  {batchData.materialManufactureDate
                    ? presentFormatedData(
                        new Date(
                          batchData.materialManufactureDate.split('T')[0]
                        )
                          .toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })
                          .replace(/ /g, '-'),
                        'NA'
                      )
                    : 'NA'}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Collapse>

        {/* <Grid item xs={12} sm={6} md={6} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            Other Information
          </Typography>
          <span className={classes.borders}></span>
        </Grid> */}

        <Grid
          container
          style={{
            marginTop: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          spacing={2}
        >
          <Grid
            item
            xs={12}
            sm={6}
            style={{
              marginTop: '0.5rem',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
            }}
          >
            {/* <Grid>
              <IconButton onClick={toggleBatch} size='small'>
                {openBatch ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowRightIcon />
                )}
              </IconButton>
            </Grid> */}
            <Grid>
              <Typography
                // className={classes.inline}
                variant='body1'
                style={{ fontWeight: 600, fontSize: '1.2rem' }}
                // variant='body2'
                // style={{ fontWeight: 500 }}
              >
                Other Information
              </Typography>
              <hr className={classes?.hrLine} />
            </Grid>
          </Grid>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            item
            xs={12}
            sm={6}
          >
            {isEditingFiles ? (
              <>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleSaveOtherInfo}
                  style={{ marginRight: 8 }}
                >
                  Save
                </Button>
                <Button variant='outlined' onClick={handleCancel}>
                  Cancel
                </Button>
              </>
            ) : (
              // <Button
              //   variant='contained'
              //   color='default'
              //   onClick={() => setIsEditing(true)}
              // >
              //   Edit
              // </Button>
              <Button
                variant='contained'
                startIcon={<CreateIcon fontSize='small' />}
                style={{
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  border: '1px solid #000000de',
                }}
                size='small'
                // onClick={() => setIsEditing(true)}
                onClick={handleEditFiles}
              >
                Edit
              </Button>
            )}
          </Grid>
        </Grid>

        {!isEditingFiles ? (
          <>
            <Grid container spacing={3}>
              {/* Row 1 */}
              <Grid item xs={12} sm={4}>
                <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                  Additional Remarks(Optional)
                </Typography>
                <Typography>{otherInformationRemarks || 'NA'}</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                  Uploaded Document List
                </Typography>
                <Typography>
                  {/* {otherFiles} */}
                  {otherFiles && otherFiles.length > 0 ? (
                    otherFiles.map((file, index) => (
                      <Typography
                        variant='body2'
                        className={classes.closeText}
                        style={{ whiteSpace: 'nowrap' }}
                        key={index}
                      >
                        {file.grFileName}
                      </Typography>
                    ))
                  ) : (
                    <Typography>-No Documents Uploaded-</Typography> // Show "-" if no files are uploaded
                  )}
                </Typography>
              </Grid>
              <Grid></Grid>
            </Grid>
          </>
        ) : (
          <OtherInfo
            isAddRecord={true}
            isEditingFiles={isEditingFiles}
            setIsEditingFiles={setIsEditingFiles}
            // handleOtherChange={handleOtherChange}
            POBatchRecordDetails={{
              ...POBatchRecordDetails,
              otherInformationRemarks: otherInformationRemarks,
            }}
            // handleAsnChange={handleAsnChange}
            handleChange={handleChange}
            handlingFiles={handlingFiles}
            //parent
            parentHandlingDeleteFile={parentHandlingDeleteFile}
            //appending file
            OtherInfoTempNumber={OtherInfoTempNumber}
            handleTempNumber={handleTempNumber}
            otherInformationRemarks={otherInformationEdit}
            setOtherInformation={setOtherInformationEdit}
            otherFiles={otherFiles}
            setOtherFiles={setOtherFiles}
          />
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            // gap: '20px',
            marginTop: 50,
            marginBottom: '2rem',
          }}
        >
          {/* Orange Button */}
          <Button className={classes.orangeButton} onClick={handleSubmitRecord}>
            Submit for Approval
          </Button>

          {/* White Button */}
          {/* <Button className={classes.whiteButton} onClick={handleSaveRecord}>
            Record Incomplete, Save Record
          </Button> */}
        </div>
      </div>
      <Dialog open={openDialog} onClose={handleClose}>
        <DialogContent className={classes.dialogContent}>
          <div className={classes.checkIcon} />
          <Typography variant='h6' style={{ fontWeight: 600 }}>
            The Record has been Saved
          </Typography>
          <div style={{ marginTop: 30 }}>
            <Button className={classes.okButton} onClick={handleClose}>
              Ok
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {updateGRNData?.status === true && (
        // <Dialog open={submitDialog} onClose={handleClose}>
        //   <DialogContent className={classes.dialogContent}>
        //     <div className={classes.checkIcon} />
        //     {/* <CheckCircleIcon className={classes.checkIcon} /> */}
        //     <Typography variant='h6' style={{ fontWeight: 500 }}>
        //       Record sent for Approval
        //     </Typography>
        //     <div style={{ marginTop: 30 }}>
        //       <Button className={classes.okButton} onClick={handleClose}>
        //         Ok
        //       </Button>
        //     </div>
        //   </DialogContent>
        // </Dialog>
        <Dialog open={submitDialog} fullWidth>
          <StyledDialog
            icons={true}
            handleClose={handleClose}
            title='Record sent for GRN Generation'
            //subtitle='Your Record has been added and sent for approval.Please Contact the Admin if you have Entered the Wrong Data.'
          />
        </Dialog>
      )}

      <Dialog open={discrepancyDialog} style={{ borderRadius: '2rem' }}>
        <DialogTitle
          onClick={() => setDiscrepancyDialog(false)}
          style={{ textAlign: 'end', height: '1.5rem' }}
        >
          <Typography style={{ fontWeight: 'bold' }}>
            Cancel <span style={{ color: 'red', fontWeight: 'bold' }}>X</span>
          </Typography>
        </DialogTitle>
        <DialogContent style={{ textAlign: 'center', padding: '4rem 8rem' }}>
          <Typography variant='h6' style={{ fontWeight: 600 }}>
            Discrepancy Detected
          </Typography>
          {asnData?.vehicleNumberSupplier !== asnData?.vehicleNumberCMO && (
            <>
              <Typography style={{ marginTop: 20, fontWeight: '550' }}>
                Vehicle Number (Supplier):{' '}
                {asnData?.vehicleNumberSupplier || 'NA'}
              </Typography>
              <Typography style={{ marginBottom: 30, fontWeight: '550' }}>
                Vehicle Number (CMO): {asnData?.vehicleNumberCMO || 'NA'}
              </Typography>
            </>
          )}
          {Number(batchData?.asnBatchQuantity) !==
            Number(batchData?.actualQuantityReceived) &&
            asnData?.vehicleNumberSupplier !== asnData?.vehicleNumberCMO && (
              <hr className={classes.hrdis} />
            )}

          {Number(batchData?.asnBatchQuantity) !==
            Number(batchData?.actualQuantityReceived) && (
            <>
              <Typography style={{ marginTop: 20, fontWeight: '550' }}>
                Actual Quantity Received (ASN): {batchData?.asnBatchQuantity}
              </Typography>
              <Typography style={{ marginBottom: 30, fontWeight: '550' }}>
                Actual Quantity Received (CMO):{' '}
                {batchData?.actualQuantityReceived}
              </Typography>
            </>
          )}

          <Button
            // variant='contained'
            // color='secondary'
            // style={{
            //   marginTop: 30,
            //   backgroundColor: '#ff6600',
            //   color: 'white',
            // }}
            className={classes.orangeButton}
            onClick={handleDiscrepancyConfirm}
          >
            Send for GRN Generation Approval
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ResolveReviewFile;
